import { useCountNewOrdersSince } from "@/api/order";
import { useCountTrash } from "@/api/trash";
import logoInventoZen from "@/assets/images/InventoZen_Logo_Horizontal_SML.png";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "@/components/ui/menubar.tsx";
import { useAuth } from "@/context/auth/AuthContext";
import { useLastTimeNewOrdersChecked } from "@/context/OrderContext";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { DownloadIcon, Trash2, UserCircle } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ContactFormModal } from "../modal/ContactFormModal";
import { EditProfileModale } from "../modal/EditProfileModal";
import NoCMSModel from "../modal/NoCMSModel";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { NotificationBadge } from "../ui/notification-badge";
import { Tooltip, TooltipTrigger, TooltipContent } from "../ui/tooltip";

const Header = () => {
  const { logout, instanceData } = useAuth();
  const { t } = useTranslation();

  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showNoCMS, setShowNoCMS] = useState(false);
  const navigate = useNavigate();

  const { lastChecked } = useLastTimeNewOrdersChecked();
  const { data: newOrders } = useCountNewOrdersSince(lastChecked);
  const { data: countTrash } = useCountTrash({});

  const haveCMSId = instanceData?.CMS?.id;

  const handleClickCMS = () => {
    if (haveCMSId) {
      navigate("/cms");
    } else {
      setShowNoCMS(true);
    }
  };
  return (
    <div className="w-full h-14 px-6 py-2 border-b border-slate-300 justify-between items-center inline-flex">
      <EditProfileModale
        open={showEditProfile}
        onOpenChange={setShowEditProfile}
      />
      <NoCMSModel open={showNoCMS} onOpenChange={setShowNoCMS} />
      <div className="h-10 justify-start items-center gap-4 flex">
        <div className="w-32  relative">
          <img
            onClick={() => navigate("/dashboard")}
            src={logoInventoZen}
            alt="logoInventoZen"
            className="w-full h-full cursor-pointer"
          />
        </div>
        <div className="justify-start items-center gap-2 flex border-l-2 border-slate-200">
          <div className="justify-start items-center gap-1 flex">
            <div className="px-4 py-2 rounded-lg justify-start items-center gap-2.5 flex">
              <Link
                to="/compte-principal"
                className="text-slate-600 text-sm font-semibold font-['Raleway'] leading-normal"
              >
                {t("mainAccount")}
              </Link>
            </div>
            {/*<div className="px-4 py-2 rounded-lg justify-start items-center gap-1 flex cursor-pointer group/submenu">
              <div className="text-slate-600 text-xs font-medium font-['Raleway'] leading-none">
                {t("menuHelp")}
              </div>
              <ChevronDownIcon className="w-3 h-3 hover:rotate-180 transition-transform group-hover/submenu:rotate-180" />
            </div>
            <div className="px-4 py-2 rounded-lg justify-start items-center gap-2.5 flex">
              <a
                href={"#"}
                className="text-slate-600 text-xs font-medium font-['Raleway'] leading-none"
              >
                {t("menuHelpDocument")}
              </a>
            </div>*/}
          </div>
        </div>
      </div>
      <Menubar className="justify-start items-center gap-4 flex border-0 shadow-none">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              onClick={() =>
                navigate("/export", {
                  state: { prevLocation: window.location.pathname },
                })
              }
              className="p-2.5 rounded-lg justify-center items-center gap-1 flex"
            >
              <DownloadIcon className="w-5 h-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            className="bg-black rounded-xl px-3"
            arrowClassName="bg-black fill-black"
          >
            <span className="text-white text-sm font-medium">
              {t("export.tooltip")}
            </span>
          </TooltipContent>
        </Tooltip>
        <ContactFormModal />
        <Button
          variant="ghost"
          onClick={() => navigate("/trash")}
          className="p-2.5 rounded-lg justify-center items-center gap-1 flex"
        >
          <NotificationBadge notifNumber={countTrash} className="bg-gray-500">
            <Trash2 className="w-5 h-5" />
          </NotificationBadge>
        </Button>
        {/*<div className="p-2.5 rounded-lg justify-center items-center gap-1 flex">
          <HelpCircleIcon className="w-5 h-5" />
        </div>*/}
        <MenubarMenu>
          <MenubarTrigger className="px-3 py-2 rounded-lg justify-center items-center gap-2 flex">
            {newOrders && newOrders > 0 ? (
              <NotificationBadge notifNumber={newOrders}>
                <UserCircle className="w-5 h-5" />
              </NotificationBadge>
            ) : (
              <UserCircle className="w-5 h-5" />
            )}
            <div className="text-slate-800 text-sm font-semibold font-['Raleway']">
              Admin
            </div>
            <ChevronDownIcon className="w-5 h-5 " />
          </MenubarTrigger>
          <MenubarContent>
            <MenubarItem onSelect={() => setShowEditProfile(true)}>
              {t("userNavProfile")}
            </MenubarItem>
            <MenubarItem onSelect={handleClickCMS}>
              {t("userNavMySite")}
            </MenubarItem>
            <MenubarItem asChild>
              <Link to="/settings">{t("myAppSettings")}</Link>
            </MenubarItem>
            {instanceData?.haveEshop == true && (
              <MenubarItem asChild className="flex flex-row justify-between">
                <Link to="/e-shop">
                  <span>{t("userNavEshop")}</span>
                  {newOrders != null && newOrders > 0 && (
                    <Badge className="p-1">{newOrders}</Badge>
                  )}
                </Link>
              </MenubarItem>
            )}
            <MenubarItem onClick={logout}>{t("logout")}</MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </div>
  );
};

export default Header;
